<template>
  <div class="content" id="endScreen" ref="endScreen">
    <div
      class="service-provide-info"
      :style="endScreenData.endScreenImage"
    >
      <div
        class="mx-md-auto text-center"
        v-if="endScreenData.in_question_type_id == vueQueTypeConfig.TYPE_END_SCREEN_TEXT"
      >
        <h1
          class="custom-text-color"
          v-if="endScreenData.endScreenTitle"
        >{{endScreenData.endScreenTitle}}</h1>
        <h5
          class="custom-text-color"
          v-if="endScreenData.endScreenSubtitle"
          v-html="formatString"></h5>
        <div class="profileImage" v-if="endScreenData.endScreenImage">
          <img
            :src="endScreenData.endScreenImage"
            class="img-responsive w-70 mx-auto profileImagePreview"
            alt
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="submit" v-if="endScreenData.endScreenButtonText">
          <button class="btn sub-main" type="button" @click.prevent="surveyCompleted">
            {{endScreenData.endScreenButtonText}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var { queTypeConfig } = require("../../../config/config.js");
export default {
  name: "StartScreen",
  computed: {
    ...mapGetters("previewSurvey", [
      "surveyMasterDetails",
      "surveyStartEndQuestions"
    ]),
    formatString: function() {
      return this.makeHyperlinks(this.surveyStartEndQuestions["end"]["validationDetailsObj"][11]);
    }
  },
  //props: ['surveyName', 'surveyDesign'],
  data() {
    return {
      endScreenData: {},
      isLoopSurvey: 0,
      vueQueTypeConfig: queTypeConfig
    };
  },
  mounted() {
    this.isLoopSurvey = this.surveyMasterDetails.in_loop_survey;
    this.endScreenData = {
      in_question_type_id: this.surveyStartEndQuestions["end"]
        .question_type_details.in_question_type_id,
      endScreenTitle: this.surveyStartEndQuestions["end"][
        "validationDetailsObj"
      ][44]
        ? this.surveyStartEndQuestions["end"]["validationDetailsObj"][44]
        : "",
      endScreenSubtitle: this.surveyStartEndQuestions["end"][
        "validationDetailsObj"
      ][11]
        ? this.surveyStartEndQuestions["end"]["validationDetailsObj"][11]
        : "",
      endScreenButtonText: this.surveyStartEndQuestions["end"][
        "validationDetailsObj"
      ][45]
        ? this.surveyStartEndQuestions["end"]["validationDetailsObj"][45]
        : "",
      endScreenImage: this.surveyStartEndQuestions["end"][
        "validationDetailsObj"
      ][15]
        ? JSON.parse(
            this.surveyStartEndQuestions["end"]["validationDetailsObj"][15]
          )["dataURL"]
        : "",
      isTimtoutOrButton: this.surveyStartEndQuestions["end"][
        "validationDetailsObj"
      ][47]
        ? 1
        : 2 // 1 => Button, 2 => Image
    };
    console.log("=== EndScreen ===");
    console.log(this.endScreenData);

    if (this.endScreenData.isTimtoutOrButton == 2) {
      let timeoutValue = this.surveyStartEndQuestions["end"][
        "validationDetailsObj"
      ][48];
      setTimeout(() => {
        this.surveyCompleted();
      }, parseInt(timeoutValue + "000"));
    }
  },
  created() {},
  methods: {
    surveyCompleted() {
      this.$emit("changeToThankYouScreen")
      // alert('Survey completed successfully 2.')
    },
    makeHyperlinks: function(input) {
      const regex = /(?:(?:https?|ftp):\/\/)?(?:www\.)?([a-zA-Z0-9.-]+(?:\.[a-zA-Z]{2,})+)\S+/gi;
      return input.replace(regex, function(match) {
        let href = match;
        if (match.includes('www')) {
          href = "https://" + match;
        } else if (match.startsWith('http')) {
          href = match;
        } else {
          href = "http://" + match;
        }

        return '<a class="st-hyperlink" href="' + href + '" target="_blank">' + match + '</a>';
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Preview/EndScreen.vue